<div class="tokens-page-container">
  <div class="tokens-page-wrapper">
    <app-tokens class="flex flex--100 tokens-page-items-wrapper"></app-tokens>
    <app-tokens-history class="flex flex--100 tokens-page-items-wrapper"></app-tokens-history>
  </div>
</div>
